import { Button, Dialog, List, Loading, Popup } from "antd-mobile";
import axios from "axios";
import style from "css/hotdesking.module.css";
import React, { useCallback, useLayoutEffect, useState } from "react";
import HotdeskingConfig from "../Config";
import { CloseOutlined, LeftOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { useTranslation } from "react-i18next";

function ShareCancel({ book, isOpen, onClose }) {
  const { t } = useTranslation();
  const [isSearch, setIsSearch] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState([]);

  const getMemberList = useCallback(() => {
    setIsLoading(true);
    const config = {
      params: {
        search_type: "share",
        book_id: book?.id,
      },
    };
    axios
      .get(`${HotdeskingConfig.baseURI}/member`, config)
      .then((res) => {
        setList(res.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [book?.id]);

  useLayoutEffect(() => {
    if (isOpen && isSearch) {
      getMemberList();
      setIsSearch(false);
    }
  }, [getMemberList, isOpen, isSearch]);

  const onClosePopup = () => {
    setList([]);
    setIsSearch(true);
    onClose();
  };
  const onCancel = (member_id) => {
    setIsLoading(true);
    const config = {
      params: {
        book_id: book.id,
        member_id: member_id,
      },
    };
    axios
      .delete(`${HotdeskingConfig.baseURI}/book/share`, config)
      .then(() => {
        setIsSearch(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const onOpenCancel = (member_id) => {
    Dialog.show({
      className: `${style.dialog} ${style.confirm}`,
      bodyClassName: `${style.dialog_body}`,
      bodyStyle: { padding: 0 },
      content: <CancelContent onCancel={() => onCancel(member_id)} />,
    });
  };

  return (
    <Popup className={`${style.popup} ${style.share}`} visible={isOpen}>
      {isLoading ? (
        <Loading />
      ) : (
        <section className={style.list_section}>
          <section className={style.list_header}>
            <p>{t("HOTDESKING.MODAL.SHARE.SHARED.TITLE")}</p>
            <LeftOutlined
              className={style.header_icon}
              onClick={onClosePopup}
            />
          </section>
          <section className={style.list_body}>
            <section className={style.content_header}>Today</section>
            <List className={style.content_body}>
              {list.map((item, idx) => (
                <List.Item
                  key={idx}
                  className={`${style.content_item} ${style.cancel}`}
                >
                  <section className={style.item_wrap}>
                    <section className={style.item_section}>
                      <Avatar
                        className={style.member_img}
                        icon={<UserOutlined className={style.member_icon} />}
                      />
                      <article className={style.member_info}>
                        <p className={style.member_name}>{item.name}</p>
                        <div className={style.member_department}>
                          <p>{item.department.name}</p>
                          <span className={style.divider} />
                          <p>{item.role}</p>
                        </div>
                      </article>
                    </section>
                    <Button
                      className={style.cancel_button}
                      onClick={() => onOpenCancel(item.id)}
                    >
                      <section className={style.cancel_content}>
                        <CloseOutlined className={style.cancel_icon} />
                        <p>{t("HOTDESKING.BUTTON.CANCEL")}</p>
                      </section>
                    </Button>
                  </section>
                </List.Item>
              ))}
            </List>
          </section>
        </section>
      )}
    </Popup>
  );
}

export default ShareCancel;

function CancelContent({ onCancel }) {
  const { t } = useTranslation();
  const onClose = () => {
    Dialog.clear();
  };
  const onSubmit = () => {
    onCancel();
    onClose();
  };
  return (
    <section className={style.confirm_content}>
      <article className={style.content_article}>
        <p>{t("HOTDESKING.MODAL.SHARE.MESSAGE.CANCEL")}</p>
      </article>
      <section className={style.content_footer}>
        <Button className={style.cancel_button} onClick={onClose}>
          {t("HOTDESKING.BUTTON.CANCEL")}
        </Button>
        <Button className={style.submit_button} onClick={onSubmit}>
          {t("HOTDESKING.BUTTON.CONFIRM")}
        </Button>
      </section>
    </section>
  );
}
